import { Box } from '@mui/material';
import { useAdvisorProfileTheme } from '../AdvisorProfile/AdvisorProfileThemeProvider';
import { useIsPortraitTablet } from 'hooks/useBreakpoints/useBreakpoints';
import LanguageButton from '../LanguageButton';
import ResponsiveWrapper from '../PageLayout/ResponsiveWrapper/ResponsiveWrapper';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from './AdviserProfileTopNav.module.css';
import clsx from 'clsx';

export function AdviserProfileTopNav({ cardId }: { cardId: string }) {
  const { mainColor } = useAdvisorProfileTheme();
  const isPortraitTablet = useIsPortraitTablet();

  const left = <Box sx={{ width: '24px', height: '24px' }}></Box>;
  const Language = (
    <LanguageButton
      className={clsx(styles.navButton)}
      sx={{ color: mainColor }}
    />
  );

  const Pagination = (
    <Box
      className={clsx(styles.swiperPagination, 'swiper-pagination')}
      sx={{ justifyContent: 'center', alignItems: 'center' }}
    />
  );

  const componentM = (
    <Box className={clsx(styles.container)}>
      {left}
      {Pagination}
      {Language}
    </Box>
  );
  const componentX = (
    <Box className={clsx(styles.container)}>
      {left}
      {Language}
    </Box>
  );

  if (isPortraitTablet) {
    return componentX;
  } else {
    return (
      <ResponsiveWrapper sizeProfiles={{ sm: 1, md: 1, lg: 1, xl: 1 }}>
        {{ sm: [componentM], lg: [componentX] }}
      </ResponsiveWrapper>
    );
  }
}

export default AdviserProfileTopNav;
